import styled from "styled-components";

export const CronContainer = styled.div`
  width: 50%;
  margin: 10px;
  background: white;
  color:black;
  display: flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
    box-shadow: 0 8px 24px rgba(255, 255, 255, 0.05),
              0 2px 6px rgba(0, 0, 0, 0.2);
`;

export const CronValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 100%;
  box-sizing: border-box;
`;

export const CronValue = styled.div`
  margin: 10px;
  font-size: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%; 
  word-break: break-word; 
  overflow-wrap: break-word;
`;


export const IntervalToggleContainer = styled.div`
  display:flex;
  align-items:start;
  height: 70px;
`;